import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RelayPortManagementComponent } from "./relay-port-management/relay-port-management.component";

const routes: Routes = [
  {
		path: "",
		component: RelayPortManagementComponent,
	},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelayPortManagementRoutingModule { }
